/**
 * Claude 素色 ECharts 全局主题注册器
 *
 * 在 `main.ts` 启动时调用 `registerClaudeTheme()` 一次，之后任何图表
 * 都可以通过 `echarts.init(el, 'claude-mono')` 或
 * `<v-chart :theme="'claude-mono'">` 继承该主题。
 *
 * 幂等：内部以 `_registered` 标志防止重复注册（HMR 友好）。
 */

import * as echarts from 'echarts/core'
import { claudeMonoTheme, CLAUDE_THEME } from './theme'

let _registered = false

/**
 * 注册 Claude 素色 ECharts 主题到全局。
 *
 * 重复调用安全（仅生效一次）。返回主题名，方便链式使用。
 */
export function registerClaudeTheme(): string {
  if (_registered) {
    return CLAUDE_THEME
  }
  echarts.registerTheme(CLAUDE_THEME, claudeMonoTheme as Record<string, unknown>)
  _registered = true
  return CLAUDE_THEME
}

/** 仅供测试场景使用：重置注册标志，下次 register 重新写入。 */
export function _resetClaudeThemeRegistration(): void {
  _registered = false
}

export { CLAUDE_THEME }
